import { Injectable } from '@angular/core';
import { SohoDataGridComponent } from 'ids-enterprise-ng';

@Injectable()
export class LMListGridUtilService {

  /**
   * Return the index on the current page of the selected row. If multiple
   * rows are selected return the first row selected.
   * @param sohoDataGridComponent Datagrid used to find the selected row.
   * @param unselectAllRows If a row is selected then unselected all rows before returning it.
   * @returns The selectedIndex on the current page or -1 if no row is selected
   */
  getSelectedIndex(sohoDataGridComponent: SohoDataGridComponent, unselectAllRows?: boolean): number {
    let selectedRowIndex = -1;
    if (this.hasSelectedRow(sohoDataGridComponent.getSelectedRows())) {
      selectedRowIndex = sohoDataGridComponent.getSelectedRows()[0].idx;
      if (unselectAllRows) {
        sohoDataGridComponent.unSelectAllRows();
      }
    }
    return selectedRowIndex;
  }

  /**
   * Returns whether there is a valid selected row or not. This means that
   * the SohoDataGridSelectedRow[0] is defined and has an idx greater than -1
   * @param selectedRows The array of selected rows retrieved from the sohoDataGrid
   * @returns
   */
  hasSelectedRow(selectedRows: SohoDataGridSelectedRow[]): boolean {
    if (!selectedRows || selectedRows.length === 0 || selectedRows[ 0 ].idx === -1) {
      return false;
    }
    return true;
  }

  /**
   * Sets the selected row to the passed in selectedRowIndex. Return true if selection was
   * make else return false.
   * @param sohoDataGridComponent The datagrid to select the row for.
   * @param selectedRowIndex The row index to select on the datagrid
   * @returns true if selection happend, otherwise false.
   */
  selectRow(sohoDataGridComponent: SohoDataGridComponent, selectedRowIndex: number): boolean {
    if (selectedRowIndex >= 0) {
      sohoDataGridComponent.selectRow(selectedRowIndex);
      return true;
    }
    return false;
  }

  unSelectAllRows(sohoDataGridComponent: SohoDataGridComponent): void {
    if (this.hasSelectedRow(sohoDataGridComponent.getSelectedRows())) {
      sohoDataGridComponent.unSelectAllRows();
    }
  }

  deactivateRow(sohoDataGridComponent: SohoDataGridComponent): void {
    if (this.hasActivatedRow(sohoDataGridComponent.activatedRow())) {
      sohoDataGridComponent.deactivateRow();
    }
  }

  getActivatedRow(sohoDataGridComponent: SohoDataGridComponent, deactivateRow = false): number {
    let activatedRowIndex = -1;
    const activatedRow = sohoDataGridComponent.activatedRow();
    if (this.hasActivatedRow(activatedRow)) {
      if (activatedRow instanceof Array) {
        activatedRowIndex = activatedRow[ 0 ].row;
      } else {
        activatedRowIndex = activatedRow.row;
      }

      if (deactivateRow) {
        sohoDataGridComponent.deactivateRow();
      }
    }
    return activatedRowIndex;
  }

  hasActivatedRow(activatedRow: any) {
    if (!activatedRow) {
      return false;
    }

    if (activatedRow instanceof Array) {
      if (activatedRow.length === 0 || activatedRow[ 0 ].row === -1) {
        return false;
      }
    }

    return true;
  }
}
